import { Importance } from '../../../components/integrations/jira/api/shared'

export const STATUS_LIST = [
  {
    value: 'REPORTED',
    name: 'Reported',
    translationId: 'title_vulnerabilityStatusReported',
    group: 'title_vulnerabilityStatusOpen'
  },
  {
    value: 'CONFIRMED',
    name: 'Confirmed',
    translationId: 'title_vulnerabilityStatusConfirmed',
    group: 'title_vulnerabilityStatusOpen'
  },
  {
    value: 'SUSPICIOUS',
    name: 'Suspicious',
    translationId: 'title_vulnerabilityStatusSuspicious',
    group: 'title_vulnerabilityStatusOpen'
  },
  {
    value: 'REMEDIATED',
    name: 'Remediated',
    translationId: 'title_vulnerabilityStatusRemediated',
    group: 'title_vulnerabilityStatusClosed'
  },
  {
    value: 'FIXED',
    name: 'Fixed',
    translationId: 'title_vulnerabilityStatusFixed',
    group: 'title_vulnerabilityStatusClosed'
  },
  {
    value: 'NOT_A_PROBLEM',
    name: 'Not a problem',
    translationId: 'title_vulnerabilityStatusNotProblem',
    group: 'title_vulnerabilityStatusClosed'
  },
  {
    value: 'AUTO_REMEDIATED',
    name: 'Remediated - Auto-verified',
    translationId: 'title_vulnerabilityStatusAutoRemediated',
    group: 'title_vulnerabilityStatusClosed'
  }
]

export const INTEGRATION_TYPE = {
  JIRA: 'JIRA',
  VSTS: 'VSTS',
  GITHUB: 'GITHUB',
  AGILE_CENTRAL: 'AGILE_CENTRAL',
  SLACK: 'SLACK',
  MICROSOFTTEAMS: 'MICROSOFTTEAMS',
  NEW_MICROSOFTTEAMS: 'NEW_MICROSOFTTEAMS',
  VICTOROPS: 'VICTOROPS',
  PAGERDUTY: 'PAGERDUTY',
  GENERIC: 'GENERIC',
  JENKINS: 'JENKINS',
  UNSUPPORTED: 'UNSUPPORTED'
}

export const SERVER_ENVIRONMENT_SELECT = [
  {
    value: 'ALL',
    name: 'All Environments',
    translationId: 'title_allEnvironments'
  },
  {
    value: 'DEVELOPMENT',
    name: 'Development',
    translationId: 'title_serverEnvironmentDevelopment'
  },
  {
    value: 'QA',
    name: 'QA',
    translationId: 'title_serverEnvironmentQualityAssurance'
  },
  {
    value: 'PRODUCTION',
    name: 'Production',
    translationId: 'title_serverEnvironmentProduction'
  }
]

export const VULN_STATUS = [
  {
    value: 'Confirmed',
    label: 'Confirmed',
    translationId: 'title_vulnerabilityStatusConfirmed'
  },
  {
    value: 'Suspicious',
    label: 'Suspicious',
    translationId: 'title_vulnerabilityStatusSuspicious'
  },
  {
    value: 'NotAProblem',
    label: 'Not a Problem',
    translationId: 'title_vulnerabilityStatusNotProblem'
  },
  {
    value: 'Remediated',
    label: 'Remediated',
    translationId: 'title_vulnerabilityStatusRemediated'
  },
  {
    value: 'AutoRemediated',
    label: 'Remediated - Auto-Verified',
    translationId: 'title_vulnerabilityStatusAutoRemediated'
  },
  {
    value: 'Reported',
    label: 'Reported',
    translationId: 'title_vulnerabilityStatusReported'
  }
]

export const VULN_STATUS_FIXED = {
  value: 'Fixed',
  label: 'Fixed',
  translationId: 'title_vulnerabilityStatusFixed'
}

export const VULNERABILITY_SUBSTATUS = [
  {
    value: 'URL',
    text: 'URL is only accessible by trusted power users',
    translationId: 'detail_vulnerabilitySubstatus_trustedURL'
  },
  {
    value: 'FP',
    text: 'False positive',
    translationId: 'detail_vulnerabilitySubstatus_falsePositive'
  },
  {
    value: 'SC',
    text: 'Goes through an internal security control',
    translationId: 'detail_vulnerabilitySubstatus_internalControl'
  },
  {
    value: 'EC',
    text: 'Attack is defended by an external control',
    translationId: 'detail_vulnerabilitySubstatus_externalControl'
  },
  {
    value: 'OT',
    text: 'Other',
    translationId: 'detail_vulnerabilitySubstatus_other'
  }
]

export const APPLICATION_IMPORTANCE_LIST: Importance[] = [
  {
    value: 'CRITICAL',
    name: 'Critical',
    translationId: 'title_appImportanceLevelCritical'
  },
  {
    value: 'HIGH',
    name: 'High',
    translationId: 'title_appImportanceLevelHigh'
  },
  {
    value: 'MEDIUM',
    name: 'Medium',
    translationId: 'title_appImportanceLevelMedium'
  },
  { value: 'LOW', name: 'Low', translationId: 'title_appImportanceLevelLow' },
  {
    value: 'UNIMPORTANT',
    name: 'Unimportant',
    translationId: 'title_appImportanceLevelUnimportant'
  }
]

export const INTEGRATION_APPLICATION_OPTIONS = [
  {
    value: 'ID',
    name: 'Application names',
    translationId: 'title_applicationNames'
  },
  {
    value: 'IMPORTANCE',
    name: 'Application importance levels',
    translationId: 'title_integrationsSettings_applicationImportanceLevels'
  },
  {
    value: 'APP_TAGS',
    name: 'Application tags',
    translationId: 'title_tags_application'
  }
]

export const RULE_SEVERITY_LIST = [
  {
    value: 'CRITICAL',
    name: 'Critical',
    translationId: 'title_vulnSeverityTypeCritical'
  },
  {
    value: 'HIGH',
    name: 'High',
    translationId: 'title_vulnSeverityTypeHigh'
  },
  {
    value: 'MEDIUM',
    name: 'Medium',
    translationId: 'title_vulnSeverityTypeMedium'
  },
  {
    value: 'LOW',
    name: 'Low',
    translationId: 'title_vulnSeverityTypeLow'
  },
  {
    value: 'NOTE',
    name: 'Note',
    translationId: 'title_vulnSeverityTypeNote'
  }
]

export const FILTER_GROUPS = {
  SEVERITY: 'SEVERITY',
  VULNERABILITY_RULES: 'ASSESS RULES',
  IMPORTANCE: 'IMPORTANCE',
  APPLICATIONS: 'APPLICATIONS',
  SERVERS: 'SERVERS',
  ENVIRONMENT: 'ENVIRONMENT',
  UNLICENSED: 'UNLICENSED',
  LICENSED: 'LICENSED',
  APP_TAGS: 'APPLICATION TAGS',
  BUILD_NUMBERS: 'BUILD NUMBERS',
  SERVER_TAGS: 'SERVER TAGS',
  VULN_TAGS: 'VULNERABILITY TAGS',
  SECURITY_STANDARDS: 'SECURITY STANDARDS',
  COMPLIANCE_POLICY: 'COMPLIANCE POLICY',
  REMEDIATION_POLICY: 'REMEDIATION POLICY'
}
